// The "View as" mode colour is purple-9: the bar, its primary button, entry
// icons and badge text, with purple-1 as the soft fill and white on the bar.
// No semantic token exists for it and the ruling is to add none (spec §10
// mapped onto existing tokens), so the legacy scale is used here, and only here.
// Dark purple-9 is too light for white type; the bar steps down to purple-7.

// ds-allow: impersonation colour is purple-9 by ruling (no new tokens)
export const IMPERSONATION_BAR = "bg-purple-9 text-white dark:bg-purple-7";
// ds-allow: impersonation colour is purple-9 by ruling (no new tokens)
export const IMPERSONATION_TEXT = "text-purple-9";
// ds-allow: impersonation colour is purple-9 by ruling (no new tokens)
export const IMPERSONATION_SOFT = "bg-purple-1 text-purple-9";
// ds-allow: impersonation colour is purple-9 by ruling (no new tokens)
export const IMPERSONATION_SOLID = "bg-purple-9 text-white";
// ds-allow: impersonation colour is purple-9 by ruling (no new tokens)
export const IMPERSONATION_EXIT =
  // ds-allow: impersonation colour is purple-9 by ruling (no new tokens)
  "bg-white text-purple-9 hover:bg-purple-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-purple-9";
